// src/questions.js

/** @type {Array<{
 *  id:string, domain:"Core 1"|"Core 2", subdomain:string,
 *  stem:string, choices:string[], answer:number,
 *  explanation:string, difficulty:"easy"|"medium"|"hard"
 * }>} */

const QUESTIONS = [
{
    id: "c1-wireless-01",
    domain: "Core 1",
    subdomain: "Networking/Wi‑Fi",
    stem: "Which wireless standard operates in the 5 GHz band and supports MU‑MIMO, commonly marketed as Wi‑Fi 5?",
    choices: ["802.11n", "802.11ac", "802.11ax", "802.11g"],
    answer: 1,
    explanation:
      "802.11ac (Wi‑Fi 5) primarily uses 5 GHz and introduced MU‑MIMO. 802.11n can use 2.4/5, 802.11ax is Wi‑Fi 6/6E, 802.11g is 2.4 GHz only.",
    difficulty: "easy",
  },
  {
    id: "c1-storage-02",
    domain: "Core 1",
    subdomain: "Storage/NVMe vs SATA",
    stem: "Compared to SATA SSDs, NVMe drives typically connect via which interface for significantly higher throughput?",
    choices: ["SAS", "PCIe", "USB 3.2", "Thunderbolt"],
    answer: 1,
    explanation: "NVMe drives ride over PCIe lanes, enabling much higher bandwidth and lower latency than SATA.",
    difficulty: "easy",
  },
  {
    id: "c1-hardware-03",
    domain: "Core 1",
    subdomain: "RAM/ECC",
    stem: "ECC memory is MOST commonly used in which environment?",
    choices: ["Gaming desktops", "Embedded IoT", "Servers/workstations", "Smartphones"],
    answer: 2,
    explanation: "ECC RAM detects and corrects single‑bit errors and is common in servers/workstations where reliability is critical.",
    difficulty: "easy",
  },
  {
    id: "c1-mobile-04",
    domain: "Core 1",
    subdomain: "Mobile/Radio",
    stem: "A user complains of poor battery life after enabling a mobile hotspot. Which is the BEST first step?",
    choices: [
      "Disable Bluetooth",
      "Reduce hotspot band to 2.4 GHz",
      "Lower screen brightness and enable power‑saving mode",
      "Switch to airplane mode",
    ],
    answer: 2,
    explanation:
      "Screens and radios drain battery. Power‑saving + brightness reduction is an immediate, low‑impact fix before altering connectivity.",
    difficulty: "medium",
  },
  {
    id: "c1-troubleshoot-05",
    domain: "Core 1",
    subdomain: "Video/No Display",
    stem: "A desktop powers on; motherboard LEDs light, but there is no video output. What is the MOST likely issue?",
    choices: [
      "Failed NIC",
      "Loose or faulty GPU/monitor cable",
      "Dead CMOS battery",
      "Incorrect time zone",
    ],
    answer: 1,
    explanation:
      "Power and board LEDs suggest power is present; no video often points to GPU/monitor/cable issues before suspecting other components.",
    difficulty: "easy",
  },
  {
    id: "c2-os-01",
    domain: "Core 2",
    subdomain: "Windows Tools",
    stem: "Which Windows tool displays IP configuration including DHCP lease details?",
    choices: ["ipconfig /all", "netstat -an", "ping -t", "chkdsk"],
    answer: 0,
    explanation: "ipconfig /all shows adapters, DHCP, DNS, and lease information.",
    difficulty: "easy",
  },
  {
    id: "c2-security-02",
    domain: "Core 2",
    subdomain: "Security/Policies",
    stem: "Which is the BEST example of least privilege?",
    choices: [
      "All users are local admins",
      "Grant read‑only access to a folder for analysts",
      "Disable password complexity",
      "Share a single admin account",
    ],
    answer: 1,
    explanation: "Least privilege grants only the access required—read‑only for analysts fits this principle.",
    difficulty: "easy",
  },
  {
    id: "c2-troubleshoot-03",
    domain: "Core 2",
    subdomain: "Malware",
    stem: "A PC shows pop‑ups even when offline. CPU usage is high and a suspicious service respawns after termination. What is the BEST next step?",
    choices: [
      "Disable Windows Update",
      "Boot into Safe Mode and run antimalware scans",
      "Rebuild the master boot record",
      "Install a new browser",
    ],
    answer: 1,
    explanation:
      "Safe Mode limits startup items and drivers, improving the chance a scanner can remove persistent malware.",
    difficulty: "medium",
  },
  {
    id: "c2-os-04",
    domain: "Core 2",
    subdomain: "Linux Basics",
    stem: "Which Linux command changes file permissions using symbolic notation (e.g., u+x)?",
    choices: ["chmod", "chown", "lsmod", "passwd"],
    answer: 0,
    explanation: "chmod modifies permissions (symbolic or octal). chown changes ownership.",
    difficulty: "easy",
  },
  {
    id: "c2-proc-05",
    domain: "Core 2",
    subdomain: "Troubleshooting Process",
    stem: "Place the CompTIA troubleshooting steps in the correct order (first to last).",
    choices: [
      "Establish a plan of action and implement the solution; Verify full system functionality and implement preventative measures; Identify the problem; Document findings, actions, and outcomes; Establish a theory of probable cause; Test the theory to determine cause",
      "Identify the problem; Establish a theory of probable cause; Test the theory to determine cause; Establish a plan of action and implement the solution; Verify full system functionality and implement preventative measures; Document findings, actions, and outcomes",
      "Identify the problem; Test the theory to determine cause; Establish a theory of probable cause; Establish a plan of action and implement the solution; Document findings, actions, and outcomes; Verify full system functionality and implement preventative measures",
      "Document findings, actions, and outcomes; Identify the problem; Establish a plan of action and implement the solution; Verify full system functionality and implement preventative measures; Establish a theory of probable cause; Test the theory to determine cause",
    ],
    answer: 1,
    explanation:
      "CompTIA order: Identify → Theory → Test → Plan/Implement → Verify/Prevent → Document.",
    difficulty: "medium",
  },
  {
    "id": "c1-wireless-06",
    "domain": "Core 1",
    "subdomain": "Networking/Wi-Fi",
    "stem": "Which channel width MOST commonly increases throughput but can raise interference on 2.4 GHz?",
    "choices": ["20 MHz", "40 MHz", "80 MHz", "160 MHz"],
    "answer": 1,
    "explanation": "40 MHz on 2.4 GHz bonds channels, boosting speed but crowding spectrum. Wider widths are typically on 5/6 GHz.",
    "difficulty": "medium"
  },
  {
    "id": "c1-wireless-07",
    "domain": "Core 1",
    "subdomain": "Networking/Wi-Fi",
    "stem": "WPA3-SAE primarily improves which aspect compared to WPA2-PSK?",
    "choices": ["MAC filtering", "Open authentication", "Protection against offline dictionary attacks", "Beamforming"],
    "answer": 2,
    "explanation": "WPA3-SAE replaces PSK with a secure handshake that reduces success of offline password-guessing.",
    "difficulty": "medium"
  },
  {
    "id": "c1-net-ethernet-01",
    "domain": "Core 1",
    "subdomain": "Networking/Ethernet",
    "stem": "Which cable type is BEST for 10 Gbps up to 55 m in a noisy environment?",
    "choices": ["Cat5e UTP", "Cat6 UTP", "Cat6a STP", "RG-6 Coax"],
    "answer": 2,
    "explanation": "Cat6a STP provides shielding and supports 10G up to 100 m; Cat6 can be limited to ~55 m at 10G.",
    "difficulty": "medium"
  },
  {
    "id": "c1-net-tools-01",
    "domain": "Core 1",
    "subdomain": "Networking/Tools",
    "stem": "Which tool verifies physical pinout and continuity on an Ethernet drop?",
    "choices": ["Packet sniffer", "Cable tester", "Tone generator", "Loopback plug"],
    "answer": 1,
    "explanation": "Cable testers check wiring, split pairs, and continuity; sniffers analyze traffic.",
    "difficulty": "easy"
  },
  {
    "id": "c1-net-ip-01",
    "domain": "Core 1",
    "subdomain": "Networking/TCP-IP",
    "stem": "Which protocol automatically assigns IP addresses and gateway information to clients?",
    "choices": ["DNS", "DHCP", "SNMP", "SMTP"],
    "answer": 1,
    "explanation": "DHCP dynamically leases IP configuration including gateway, mask, DNS.",
    "difficulty": "easy"
  },
  {
    "id": "c1-net-ports-01",
    "domain": "Core 1",
    "subdomain": "Networking/Ports",
    "stem": "Which port is used by HTTPS?",
    "choices": ["80", "53", "443", "25"],
    "answer": 2,
    "explanation": "HTTPS defaults to TCP 443; HTTP is 80, DNS 53, SMTP 25.",
    "difficulty": "easy"
  },
  {
    "id": "c1-printer-01",
    "domain": "Core 1",
    "subdomain": "Printers/Laser",
    "stem": "Streaks repeating at regular intervals on a laser printout MOST likely indicate a problem with the:",
    "choices": ["Imaging drum", "Transfer belt", "Fuser rollers", "Duplexer"],
    "answer": 0,
    "explanation": "Defects on the drum surface repeat as it rotates; fuser defects often smear or fix poorly.",
    "difficulty": "medium"
  },
  {
    "id": "c1-printer-02",
    "domain": "Core 1",
    "subdomain": "Printers/Inkjet",
    "stem": "Which maintenance is MOST appropriate for missing lines on inkjet prints?",
    "choices": ["Replace fuser", "Calibrate colors", "Run printhead cleaning", "Replace transfer roller"],
    "answer": 2,
    "explanation": "Clogged nozzles cause banding; run cleaning cycles or replace the cartridge/printhead.",
    "difficulty": "easy"
  },
  {
    "id": "c1-display-01",
    "domain": "Core 1",
    "subdomain": "Displays",
    "stem": "A laptop LCD shows a very dim image but is still visible under light. What’s the FIRST component to check?",
    "choices": ["Backlight/inverter", "GPU", "LCD panel", "RAM"],
    "answer": 0,
    "explanation": "A faint image indicates the panel is receiving video but the backlight path failed.",
    "difficulty": "easy"
  },
  {
    "id": "c1-storage-03",
    "domain": "Core 1",
    "subdomain": "Storage/Raid",
    "stem": "Which RAID level provides striping with parity and can withstand a single drive failure?",
    "choices": ["RAID 0", "RAID 1", "RAID 5", "RAID 10"],
    "answer": 2,
    "explanation": "RAID 5 uses distributed parity; RAID 1 mirrors; RAID 0 has no redundancy; RAID 10 mirrors+stripes.",
    "difficulty": "easy"
  },
  {
    "id": "c1-storage-04",
    "domain": "Core 1",
    "subdomain": "Storage/Interfaces",
    "stem": "Which connector is typical for SATA power?",
    "choices": ["4-pin Molex", "6-pin PCIe", "15-pin SATA power", "8-pin EPS"],
    "answer": 2,
    "explanation": "SATA power uses a 15-pin connector; Molex is older 4-pin peripheral power.",
    "difficulty": "easy"
  },
  {
    "id": "c1-hardware-04",
    "domain": "Core 1",
    "subdomain": "Hardware/CPU",
    "stem": "Which is TRUE about CPU thermal paste?",
    "choices": ["It replaces the heatsink", "It fills microscopic gaps between IHS and cooler", "It increases voltage to the CPU", "It is only for water cooling"],
    "answer": 1,
    "explanation": "Thermal compound improves heat transfer by filling air gaps.",
    "difficulty": "easy"
  },
  {
    "id": "c1-hardware-05",
    "domain": "Core 1",
    "subdomain": "Hardware/RAM",
    "stem": "Which would MOST likely cause frequent random reboots after a RAM upgrade?",
    "choices": ["Incorrect channel population", "Too much storage", "Faulty SATA cable", "Disabled virtualization"],
    "answer": 0,
    "explanation": "Mismatched modules or wrong slots can destabilize memory timing.",
    "difficulty": "medium"
  },
  {
    "id": "c1-hardware-06",
    "domain": "Core 1",
    "subdomain": "Hardware/PSU",
    "stem": "A system powers on then immediately shuts off under GPU load. Which is MOST likely?",
    "choices": ["Insufficient PSU wattage", "Bad NIC", "Dead CMOS battery", "Wrong locale settings"],
    "answer": 0,
    "explanation": "High load causing brown-outs points to power delivery problems.",
    "difficulty": "easy"
  },
  {
    "id": "c1-mobile-05",
    "domain": "Core 1",
    "subdomain": "Mobile/Accessories",
    "stem": "Which mobile accessory provides contactless payments?",
    "choices": ["Bluetooth", "NFC", "Infrared", "ANT+"],
    "answer": 1,
    "explanation": "NFC enables tap-to-pay and close-range data exchange.",
    "difficulty": "easy"
  },
  {
    "id": "c1-virt-01",
    "domain": "Core 1",
    "subdomain": "Virtualization",
    "stem": "A developer runs multiple OSs on one laptop using a Type-2 hypervisor. What hardware feature should be enabled for best performance?",
    "choices": ["TPM", "Secure Boot", "Hardware virtualization (Intel VT-x/AMD-V)", "PXE"],
    "answer": 2,
    "explanation": "VT-x/AMD-V offloads virtualization to CPU extensions.",
    "difficulty": "easy"
  },
  {
    "id": "c1-cloud-01",
    "domain": "Core 1",
    "subdomain": "Cloud",
    "stem": "Which cloud model provides complete applications to users over the Internet?",
    "choices": ["IaaS", "PaaS", "SaaS", "On-prem"],
    "answer": 2,
    "explanation": "SaaS delivers full apps; PaaS provides app platforms; IaaS provides virtualized infrastructure.",
    "difficulty": "easy"
  },
  {
    "id": "c1-troubleshoot-06",
    "domain": "Core 1",
    "subdomain": "Troubleshooting/Overheating",
    "stem": "A gaming PC thermal-throttles minutes after startup. FIRST step?",
    "choices": ["Reinstall OS", "Reseat cooler and verify fan curves", "Replace PSU", "Disable SMT"],
    "answer": 1,
    "explanation": "Check cooler seating, paste, airflow, and fan profiles before deeper changes.",
    "difficulty": "medium"
  },
  {
    "id": "c1-troubleshoot-07",
    "domain": "Core 1",
    "subdomain": "Troubleshooting/Storage",
    "stem": "An NVMe drive intermittently vanishes. Which BIOS/UEFI setting should be checked first?",
    "choices": ["SATA mode AHCI/IDE", "PCIe slot bifurcation and NVMe support", "Wake-on-LAN", "CSM video mode"],
    "answer": 1,
    "explanation": "M.2 sockets can share lanes; ensure PCIe/NVMe mode and lane mapping are correct.",
    "difficulty": "medium"
  },
  {
    "id": "c1-periph-01",
    "domain": "Core 1",
    "subdomain": "Peripherals",
    "stem": "Which connector is MOST associated with high-bandwidth external storage enclosures?",
    "choices": ["DisplayPort", "Thunderbolt", "HDMI", "PS/2"],
    "answer": 1,
    "explanation": "Thunderbolt provides PCIe over cable for fast storage docks.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-01",
    "domain": "Core 2",
    "subdomain": "Windows/CLI",
    "stem": "Which command lists active TCP connections and listening ports?",
    "choices": ["ipconfig /all", "netstat -an", "nslookup", "tasklist"],
    "answer": 1,
    "explanation": "netstat -an shows sockets and states.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-02",
    "domain": "Core 2",
    "subdomain": "Windows/Tools",
    "stem": "Which Windows utility edits startup applications for a user account?",
    "choices": ["Services.msc", "Task Manager → Startup", "Disk Cleanup", "Event Viewer"],
    "answer": 1,
    "explanation": "Task Manager’s Startup tab controls user startup apps.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-03",
    "domain": "Core 2",
    "subdomain": "Windows/Recovery",
    "stem": "Which option restores Windows to a previous working configuration without affecting personal files?",
    "choices": ["Factory reset (Remove everything)", "System Restore", "Clean install", "Format C:"],
    "answer": 1,
    "explanation": "System Restore rolls back system files and registry; personal files remain.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-04",
    "domain": "Core 2",
    "subdomain": "Windows/File Systems",
    "stem": "Which file system supports quotas, EFS, and permissions on Windows desktop?",
    "choices": ["FAT32", "exFAT", "NTFS", "ext4"],
    "answer": 2,
    "explanation": "NTFS provides permissions, compression, encryption, quotas.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-05",
    "domain": "Core 2",
    "subdomain": "Windows/Policies",
    "stem": "Where do you centrally enforce password complexity and lockout rules in a domain?",
    "choices": ["Local Security Policy", "Group Policy (GPO)", "Task Scheduler", "Device Manager"],
    "answer": 1,
    "explanation": "GPOs apply policies across OU/domain scope.",
    "difficulty": "medium"
  },
  {
    "id": "c2-linux-01",
    "domain": "Core 2",
    "subdomain": "Linux/Permissions",
    "stem": "Which command changes file ownership to user 'alex' and group 'staff'?",
    "choices": ["chmod alex:staff file", "chown alex:staff file", "usermod -g staff alex file", "groupadd staff file"],
    "answer": 1,
    "explanation": "chown user:group filename updates owner and group.",
    "difficulty": "easy"
  },
  {
    "id": "c2-linux-02",
    "domain": "Core 2",
    "subdomain": "Linux/Networking",
    "stem": "Which command displays current IP addresses in most Linux distros?",
    "choices": ["ifconfig -a", "ip addr", "route print", "hostnamectl"],
    "answer": 1,
    "explanation": "The modern tool is 'ip'; 'ifconfig' may be deprecated.",
    "difficulty": "easy"
  },
  {
    "id": "c2-linux-03",
    "domain": "Core 2",
    "subdomain": "Linux/Packages",
    "stem": "On Debian/Ubuntu, which installs a package named 'htop'?",
    "choices": ["dnf install htop", "apt install htop", "zypper in htop", "pacman -S htop"],
    "answer": 1,
    "explanation": "apt is the Debian/Ubuntu package manager front-end.",
    "difficulty": "easy"
  },
  {
    "id": "c2-macos-01",
    "domain": "Core 2",
    "subdomain": "macOS",
    "stem": "Which macOS tool collects system info for troubleshooting to share with support?",
    "choices": ["System Information", "Keychain Access", "Disk Utility", "Console only"],
    "answer": 0,
    "explanation": "System Information (About This Mac → System Report) exports hardware/software details.",
    "difficulty": "easy"
  },
  {
    "id": "c2-security-03",
    "domain": "Core 2",
    "subdomain": "Security/Threats",
    "stem": "Which BEST describes ransomware?",
    "choices": ["Tracks browsing history", "Encrypts data and demands payment", "Displays ads", "Steals CPU cycles for crypto mining only"],
    "answer": 1,
    "explanation": "Ransomware encrypts files and requests ransom to restore access.",
    "difficulty": "easy"
  },
  {
    "id": "c2-security-04",
    "domain": "Core 2",
    "subdomain": "Security/Hardening",
    "stem": "Which control MOST directly reduces credential reuse across websites?",
    "choices": ["Password expiration", "Account lockout", "Unique password manager-generated passwords", "Single shared admin account"],
    "answer": 2,
    "explanation": "Managers generate/remember unique passwords per site.",
    "difficulty": "easy"
  },
  {
    "id": "c2-security-05",
    "domain": "Core 2",
    "subdomain": "Security/Wireless",
    "stem": "For a small office Wi-Fi, which settings are MOST secure out of the box?",
    "choices": ["Open network + captive portal", "WEP + hidden SSID", "WPA3-Personal + long passphrase", "WPA2-TKIP"],
    "answer": 2,
    "explanation": "WPA3-Personal with strong passphrase is current best practice for small office.",
    "difficulty": "easy"
  },
  {
    "id": "c2-security-06",
    "domain": "Core 2",
    "subdomain": "Security/Authentication",
    "stem": "Which is TRUE multi-factor authentication?",
    "choices": ["Password + PIN", "Password + SMS code", "Two passwords", "Two security questions"],
    "answer": 1,
    "explanation": "MFA uses different factors (something you know + something you have).",
    "difficulty": "easy"
  },
  {
    "id": "c2-browser-01",
    "domain": "Core 2",
    "subdomain": "Browsers",
    "stem": "A user reports pop-ups and redirects. FIRST best step?",
    "choices": ["Disable Java", "Clear cache only", "Check installed extensions and remove suspicious ones", "Factory reset OS"],
    "answer": 2,
    "explanation": "Malicious extensions commonly cause pop-ups/redirects.",
    "difficulty": "easy"
  },
  {
    "id": "c2-scripting-01",
    "domain": "Core 2",
    "subdomain": "Scripting",
    "stem": "Which PowerShell cmdlet lists running processes?",
    "choices": ["ps", "Get-Process", "tasklist.exe only", "Get-Item"],
    "answer": 1,
    "explanation": "Get-Process is the native PowerShell cmdlet (alias: ps).",
    "difficulty": "easy"
  },
  {
    "id": "c2-scripting-02",
    "domain": "Core 2",
    "subdomain": "Scripting",
    "stem": "In Bash, which makes a script executable?",
    "choices": ["chmod +x script.sh", "chown +x script.sh", "runas script.sh", "exec script.sh"],
    "answer": 0,
    "explanation": "chmod +x sets execute permission bits.",
    "difficulty": "easy"
  },
  {
    "id": "c2-troubleshoot-04",
    "domain": "Core 2",
    "subdomain": "OS/BSOD",
    "stem": "A Windows PC intermittently BSODs after a driver update. FIRST action?",
    "choices": ["Replace motherboard", "Roll back the driver", "Disable Windows Update permanently", "Replace PSU"],
    "answer": 1,
    "explanation": "Driver rollbacks target recent changes that introduced instability.",
    "difficulty": "easy"
  },
  {
    "id": "c2-troubleshoot-05",
    "domain": "Core 2",
    "subdomain": "OS/Startup",
    "stem": "A system boots to 'Operating System not found' after adding a second drive. What’s MOST likely?",
    "choices": ["RAM failure", "Boot order changed in BIOS/UEFI", "GPU failure", "Wrong regional format"],
    "answer": 1,
    "explanation": "BIOS may try to boot the new blank disk; set the correct boot device.",
    "difficulty": "easy"
  },
  {
    "id": "c2-troubleshoot-06",
    "domain": "Core 2",
    "subdomain": "OS/Permissions",
    "stem": "A user cannot save to a shared folder but can read files. Which permission is missing?",
    "choices": ["Read", "Write/Modify", "Execute", "Full Control only"],
    "answer": 1,
    "explanation": "Write/Modify is required to create or change files.",
    "difficulty": "easy"
  },
  {
    "id": "c2-troubleshoot-07",
    "domain": "Core 2",
    "subdomain": "OS/Malware",
    "stem": "After malware cleanup, what’s the BEST next step?",
    "choices": ["Reimage immediately", "Verify restore points are deleted and create a new baseline", "Disable antivirus", "Disable firewall"],
    "answer": 1,
    "explanation": "Old restore points may reintroduce malware; create a known-good baseline.",
    "difficulty": "medium"
  },
  {
    "id": "c2-accounts-01",
    "domain": "Core 2",
    "subdomain": "Accounts",
    "stem": "Which Windows account type should everyday users have by default?",
    "choices": ["Administrator", "Power user", "Standard user", "Guest"],
    "answer": 2,
    "explanation": "Standard limits risk and follows least-privilege.",
    "difficulty": "easy"
  },
  {
    "id": "c2-backup-01",
    "domain": "Core 2",
    "subdomain": "Backup",
    "stem": "Which backup type stores only changes since the last full backup and clears the archive bit?",
    "choices": ["Differential", "Incremental", "Snapshot", "Image"],
    "answer": 1,
    "explanation": "Incremental clears the archive bit and backs up changes since the last full or incremental.",
    "difficulty": "medium"
  },
  {
    "id": "c2-backup-02",
    "domain": "Core 2",
    "subdomain": "Backup",
    "stem": "You need the fastest restore to a recent point in time with moderate storage use. Which strategy?",
    "choices": ["Full only, daily", "Full weekly + daily differential", "Full weekly + daily incremental", "Incremental only"],
    "answer": 1,
    "explanation": "Differentials restore quickly (full + latest diff) while controlling backup time/size.",
    "difficulty": "medium"
  },
  {
    "id": "c2-policies-01",
    "domain": "Core 2",
    "subdomain": "Policies/Compliance",
    "stem": "Which policy addresses acceptable use of company devices and services?",
    "choices": ["BYOD policy", "AUP", "DLP", "DRP"],
    "answer": 1,
    "explanation": "Acceptable Use Policy defines appropriate and prohibited activities.",
    "difficulty": "easy"
  },
  {
    "id": "c2-privacy-01",
    "domain": "Core 2",
    "subdomain": "Privacy",
    "stem": "Which practice reduces exposure of sensitive data in screenshots and logs?",
    "choices": ["Data minimization and masking", "Open shares", "Shared admin accounts", "Disable screen lock"],
    "answer": 0,
    "explanation": "Masking and minimizing reduce accidental disclosure.",
    "difficulty": "easy"
  },
  {
    "id": "c1-cables-01",
    "domain": "Core 1",
    "subdomain": "Cables/Video",
    "stem": "Which standard supports daisy-chaining multiple monitors on one port?",
    "choices": ["HDMI", "DVI-D", "DisplayPort (MST)", "VGA"],
    "answer": 2,
    "explanation": "DisplayPort MST enables multiple displays off a single output.",
    "difficulty": "medium"
  },
  {
    "id": "c1-cables-02",
    "domain": "Core 1",
    "subdomain": "Cables/USB",
    "stem": "Which USB connector is reversible and supports the latest PD charging specs?",
    "choices": ["USB-A", "USB-B", "USB-Mini", "USB-C"],
    "answer": 3,
    "explanation": "USB-C is reversible and used for modern data/video/power.",
    "difficulty": "easy"
  },
  {
    "id": "c1-mobile-06",
    "domain": "Core 1",
    "subdomain": "Mobile/MDM",
    "stem": "Company phones must enforce a passcode, remote wipe, and app control. Which solution?",
    "choices": ["NAT gateway", "MDM", "QoS", "IDS"],
    "answer": 1,
    "explanation": "Mobile Device Management enforces policy, inventory, wipe, and app restrictions.",
    "difficulty": "easy"
  },
  {
    "id": "c1-troubleshoot-08",
    "domain": "Core 1",
    "subdomain": "Troubleshooting/Networking",
    "stem": "Users cannot reach external sites by name but can by IP. What’s the likely cause?",
    "choices": ["DHCP exhausted", "DNS issue", "Switch loop", "Duplicate MAC addresses"],
    "answer": 1,
    "explanation": "Name resolution failure indicates DNS problem while IP routing works.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-06",
    "domain": "Core 2",
    "subdomain": "Windows/Storage",
    "stem": "Which tool checks and repairs logical file system errors on NTFS?",
    "choices": ["sfc /scannow", "DISM /RestoreHealth", "chkdsk /f", "format /q"],
    "answer": 2,
    "explanation": "chkdsk /f fixes NTFS logical issues; SFC repairs system files; DISM repairs component store.",
    "difficulty": "easy"
  },
  {
    "id": "c2-windows-07",
    "domain": "Core 2",
    "subdomain": "Windows/Security",
    "stem": "Which Windows feature isolates untrusted sites for safer browsing in Edge on supported editions?",
    "choices": ["Windows Sandbox", "Secure Boot", "BitLocker", "UEFI CSB"],
    "answer": 0,
    "explanation": "Windows Sandbox contains untrusted apps/sites; Edge also has Application Guard on Enterprise/Pro.",
    "difficulty": "medium"
  },
  {
    "id": "c2-auth-01",
    "domain": "Core 2",
    "subdomain": "Auth/Directory",
    "stem": "Which service provides centralized authentication and policy in Microsoft domains?",
    "choices": ["RADIUS only", "Active Directory", "LDAP on Linux only", "NTP"],
    "answer": 1,
    "explanation": "Active Directory is Microsoft’s directory service using LDAP/Kerberos protocols.",
    "difficulty": "easy"
  },
  {
    "id": "c2-security-07",
    "domain": "Core 2",
    "subdomain": "Security/Physical",
    "stem": "Which control BEST protects laptops left at a hot desk?",
    "choices": ["Cable lock", "Port mirroring", "Proxy server", "NAT"],
    "answer": 0,
    "explanation": "Physical cable locks deter theft in shared spaces.",
    "difficulty": "easy"
  },
  {
    "id": "c1-virt-02",
    "domain": "Core 1",
    "subdomain": "Virtualization/Snapshots",
    "stem": "What’s a risk of running VMs long-term from snapshots?",
    "choices": ["More CPU cores", "Reduced disk performance and growing delta files", "Improved IOPS", "Lower memory use"],
    "answer": 1,
    "explanation": "Snapshots increase storage overhead and can degrade performance if left in place.",
    "difficulty": "medium"
  },
  {
    "id": "c1-hw-gpu-01",
    "domain": "Core 1",
    "subdomain": "Hardware/GPU",
    "stem": "A system has both iGPU and dGPU. No display on the monitor connected to the motherboard port. Why?",
    "choices": ["Bad PSU", "RAM failure", "BIOS set to use discrete GPU only", "SSD failure"],
    "answer": 2,
    "explanation": "Many boards disable iGPU outputs if a discrete GPU is primary.",
    "difficulty": "medium"
  },
  {
    "id": "c1-net-vlan-01",
    "domain": "Core 1",
    "subdomain": "Networking/VLAN",
    "stem": "Which is TRUE about VLANs?",
    "choices": ["They require different switches", "They segment Layer-2 networks logically", "They replace routing", "They only work on Wi-Fi"],
    "answer": 1,
    "explanation": "VLANs partition L2 broadcast domains on the same switch; inter-VLAN traffic needs routing.",
    "difficulty": "easy"
  },
  {
    "id": "c1-net-poe-01",
    "domain": "Core 1",
    "subdomain": "Networking/PoE",
    "stem": "An IP camera receives power over the Ethernet cable. Which standard supports this?",
    "choices": ["802.3af/at/bt", "802.11ax", "802.1X", "802.1Q"],
    "answer": 0,
    "explanation": "PoE standards are 802.3af (15.4W), at (30W), bt (up to ~90W).",
    "difficulty": "easy"
  }

  ,
  {
    id: "c1-psu-02",
    domain: "Core 1",
    subdomain: "Hardware/PSU",
    stem: "Which is a PRIMARY advantage of a modular power supply compared to a non-modular unit?",
    choices: [
      "Easier cable management and fewer unused cables",
      "Higher voltage output across all rails",
      "Removes the need for a UPS",
      "Automatically balances load across rails"
    ],
    answer: 0,
    explanation: "Modular PSUs let you attach only the cables you need, reducing clutter and improving airflow.",
    difficulty: "easy"
  },
  {
    id: "c2-security-08",
    domain: "Core 2",
    subdomain: "Security/Hardware",
    stem: "What is the primary purpose of a Trusted Platform Module (TPM)?",
    choices: [
      "Securely store cryptographic keys and platform measurements",
      "Increase CPU clock speed",
      "Provide additional RAM",
      "Act as a GPU offload"
    ],
    answer: 0,
    explanation: "TPMs securely store cryptographic keys and platform measurements (e.g., for BitLocker, Secure/Measured Boot, and attestation).",
    difficulty: "easy"
  },
  {
    id: "c1-net-ipv6-02",
    domain: "Core 1",
    subdomain: "Networking/TCP-IP",
    stem: "Which IPv6 prefix designates a link-local address?",
    choices: ["fe80::/10", "fc00::/7", "2000::/3", "ff00::/8"],
    answer: 0,
    explanation: "IPv6 link-local addresses begin with fe80::/10 and are valid only on the local link.",
    difficulty: "medium"
  },
  {
    id: "c1-storage-05",
    domain: "Core 1",
    subdomain: "Storage/Drives",
    stem: "Which technology reports drive health metrics like reallocated sectors and temperature?",
    choices: ["S.M.A.R.T.", "TRIM", "NCQ", "RAID"],
    answer: 0,
    explanation: "S.M.A.R.T. (Self-Monitoring, Analysis and Reporting Technology) provides drive health statistics to predict failures.",
    difficulty: "easy"
  },
  {
    id: "c1-storage-06",
    domain: "Core 1",
    subdomain: "Storage/SSD",
    stem: "What does wear leveling on an SSD primarily reduce?",
    choices: ["Uneven block wear and premature failure", "Boot time", "Network latency", "File fragmentation on HDDs"],
    answer: 0,
    explanation: "Wear leveling distributes writes across flash cells to avoid wearing out specific blocks too quickly.",
    difficulty: "medium"
  },
  {
    id: "c2-virt-03",
    domain: "Core 2",
    subdomain: "Virtualization/Containers",
    stem: "Which statement BEST distinguishes a container from a full virtual machine?",
    choices: [
      "Containers share the host OS kernel while VMs include a guest OS",
      "Containers always provide stronger isolation than VMs",
      "Containers require dedicated hardware virtualization features",
      "Containers cannot be networked"
    ],
    answer: 0,
    explanation: "Containers use the host kernel (lighter weight); VMs virtualize hardware and run complete guest OS instances.",
    difficulty: "medium"
  },
  {
    id: "c2-troubleshoot-08",
    domain: "Core 2",
    subdomain: "Troubleshooting/Peripherals",
    stem: "A USB device is not recognized by Windows. What is the BEST first troubleshooting step?",
    choices: [
      "Try a different known-good USB port and cable",
      "Reinstall the OS",
      "Disable Windows Update",
      "Replace the motherboard"
    ],
    answer: 0,
    explanation: "Swapping ports/cables quickly rules out simple connectivity issues before deeper driver or hardware troubleshooting.",
    difficulty: "easy"
  },
  {
    id: "c1-raid-02",
    domain: "Core 1",
    subdomain: "Storage/RAID",
    stem: "Which statement is TRUE about RAID 10 (1+0)?",
    choices: [
      "It requires at least four drives and provides both mirroring and striping",
      "It requires only two drives and provides parity",
      "It has no redundancy and focuses on capacity",
      "It is the same as RAID 5"
    ],
    answer: 0,
    explanation: "RAID 10 combines mirroring and striping; it needs a minimum of four drives (two mirrored pairs striped together).",
    difficulty: "medium"
  }
];

export default QUESTIONS;